<div class="flex-control flex-column flex-height">
  <app-tabs>
    <li (click)="tabs_service.deactivate_tab()" [class.active]="!tabs_service.is_active()">
      <i class="fa fa-envelope-o mr-sm"></i>Secure Messaging
    </li>
  </app-tabs>

  <div class="updox-layout" [hidden]="tabs_service.is_active()">

    <!-- Column 1: Folder list -->
    <div class="updox-folder-col flex-height scroll-browser">
      <app-updox-folder-list
        [activeView]="activeView"
        [userAddress]="updoxUserAddress"
        [counts]="folderCountsView"
        (folderSelected)="onFolderSelected($event)"
        (newMessage)="openCompose()">
      </app-updox-folder-list>
    </div>

    <!-- Column 2: Message list (hidden in contacts view) -->
    <div class="updox-message-col flex-height scroll-browser" *ngIf="!isContactsView">
      <app-updox-message-list
        [folder]="activeFolder"
        [practiceId]="practiceId"
        [reloadTrigger]="triggerFolderReload"
        (messageSelected)="onMessageSelected($event)"
        (countsChanged)="onCountsChanged($event)">
      </app-updox-message-list>
    </div>

    <!-- Column 3: Detail / Contacts -->
    <div class="updox-detail-col flex-height scroll-browser">
      <app-updox-contacts
        *ngIf="isContactsView"
        [practiceId]="practiceId"
        (composeToContact)="openComposeForContact($event)">
      </app-updox-contacts>

      <app-updox-message-detail
        *ngIf="!isContactsView"
        [message]="selectedMessage"
        (reply)="openReply($event)"
        (editDraft)="onEditDraft($event)"
        (deleted)="onMessageDeleted($event)">
      </app-updox-message-detail>
    </div>

  </div>

  <!-- Compose tray: bottom-right floating windows -->
  <div class="updox-compose-tray">
    <app-updox-compose
      *ngFor="let draft of composeDrafts"
      [draft]="draft"
      [practiceId]="practiceId"
      (close)="closeCompose(draft.localId)"
      (sent)="onMessageSent($event)"
      (savedAsDraft)="onDraftSaved($event)">
    </app-updox-compose>
  </div>
</div>
